import { PROJECTS_COMPONENTS_QUERY_PARAMS } from '@atlassian/jira-common-constants/src/projects-components-query-params.tsx';
import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectComponentsRedirectRoute: InvariantJiraRoute = {
	name: 'project-components-redirect',
	path: '/projects/:projectKey',
	query: PROJECTS_COMPONENTS_QUERY_PARAMS,
};
